import { useEntity} from "react-admin-base";
import { EntityEditor } from 'react-admin-base-bootstrap';
import {Breadcrumb} from 'react-admin-base-nazox';

import { Navigate, useParams } from "react-router-dom";
import { ContentInput } from '../../Components/ContentInput';

export default function PageEntity() {
    const { id } = useParams();
    const entity = useEntity('/page', id, { values: { } });
    const [data, setData] = entity;

    return <Breadcrumb
        data={
            [
                {
                    href: '/page',
                    name: 'Pages'
                },
                {
                    href: id ? '/page/' + data.id + '/edit' : '/page/create',
                    name: id ? 'Edit' : 'Create'
                }
            ]
        }
    >
        { !id && data.id && <Navigate to={"../" + data.id + "/edit"} replace />}
        <EntityEditor entity={entity}>
            <ContentInput
                value={data.content}
                onChange={a => setData({ content: a })}
            />
        </EntityEditor>
    </Breadcrumb>;
}
